import { desc } from "framer-motion/client";
import blog1 from "../assets/On Grid.png";
import blog2 from "../assets/ground-mounted-vs-rooftop-solar.jpg"
import blog3 from "../assets/solar-subsidy-in-india.jpeg";
import blog4 from "../assets/Solar EPC Company in India.png"; // add your image

const blogsData = [
  {
    id: 1,
    slug: "on-grid-vs-off-grid-solar-system",
    category: "Solar Guide",

    title: "On Grid vs Off-Grid Solar System: Which One Should You Choose?",

    shortDescription:
      "When exploring the choice between an <a class='text-[#117816] hover:underline' href='/blogs/on-grid-vs-off-grid-solar-system'>On Grid vs Off-Grid Solar System</a>, it often starts with a simple thought - “Is solar really right for me?” Maybe you’ve noticed rising electricity bills, or perhaps the idea of energy independence has caught your attention. But then comes the confusion: should you go for an On Grid Solar System or an Off-Grid one? You’re not alone in this. It’s a question almost everyone faces at the beginning of their solar journey - and the answer isn’t always straightforward. It depends on how you live, where you live, and what you expect from your system. Let’s walk through it together and make it easier to understand.",

    image:
      blog1,

    author: "Savorka",
    date: "22 Apr 2026",
    readTime: "5 min read",

    content: [
      {
        heading: "First, What is an On Grid Solar System? ",
        description:
          "An On Grid Solar System is connected to your regular electricity supply (the grid). So, when your solar panels generate electricity during the day, your home uses it instantly. And if there’s extra power? It goes back to the grid, sometimes even earning you credits (thanks to net metering). At night or during low sunlight, your home simply uses electricity from the grid like usual. With solar connected to the grid, you enjoy smarter savings on your electricity bills."
      },

      {
        heading: "What is an Off-Grid Solar System?",
        description:
          "An off-grid system works completely independently. It doesn’t rely on the electricity grid at all. Instead, it stores solar energy in batteries so you can use it anytime, day or night. With solar and batteries, you achieve complete energy independence. Sounds great, right? It is, but it comes with a higher cost. "
      },

      {
        heading: "So, What’s the Real Difference?",
        subheading:
          "Think of it like this:",
        points: [
          "An On Grid Solar System helps you save money",
          "An Off-Grid Solar System helps you stay independent"
        ],
        description:"With an On Grid Solar System, you don’t have to worry about storing energy or managing batteries. It’s a simpler, more cost-effective setup that works best where electricity supply is stable. You use solar when it’s available and switch seamlessly to the grid when it’s not making it both convenient and efficient. On the other hand, an Off-Grid Solar System is designed for reliability in areas where electricity isn’t dependable. It stores energy in batteries, so you have power even during nights or outages. While this gives you complete independence, it also comes with higher costs and more maintenance. If your area already has a stable electricity supply, going off-grid might be unnecessary and more expensive than needed. But if you face frequent power cuts or live in a remote location, an off-grid system can be a real lifesaver, ensuring you always have power when you need it. If your area already has a stable electricity supply, going off-grid might be unnecessary. But if you face frequent power cuts or live in a remote location, off-grid can be a lifesaver. "

      },

      {
        heading: "When Should You Choose an On Grid Solar System?",
        subheading: "An On Grid Solar System is perfect if:",
        points: [
          "You live in a city or town with regular electricity",
          "Your main goal is to reduce electricity bills",
          "You want a cost-effective solution ",
          "You prefer low maintenance (no batteries to worry about)",
        ],
        description: "This is why most homes and businesses in India prefer this option- it’s simple, efficient, and budget-friendly."
      },

      {
        heading: "When Does Off-Grid Make More Sense?",
        subheading: "Go for an Off-Grid system if:",
         
        points: [
          "You live in a remote area with no reliable electricity ",
          "You want complete independence from the grid ",
          "Power cuts are a major issue for you ",
          
        ],
        description:"Just keep in mind-batteries increase both the cost and maintenance.",
      },

      {
        heading: "Let’s Be Honest-Which One is Better?",
        description:
          "For most people, an On Grid Solar System is the smarter choice. ",
          subheading: "It gives you: ",
        points: [
          "Maximum savings ",
          "Lower upfront cost ",
          "Faster return on investment ",
          
        ],
            description:"Unless you specifically need independence, staying connected to the grid while using solar is the best of both worlds. "
      },

      {
        heading: "Final Thoughts ",
        description:
          "Switching to solar is a big step, and a smart one. But choosing the right type of system makes all the difference. If your goal is to cut electricity bills and get the best value, an On Grid Solar System is likely the perfect fit for you.",
        
      },

      {
        heading: "Need Help Deciding? ",
        description:
          "At <a class='text-[#117816] hover:underline' href='/'>Savorka Solar</a>, we don’t just install panels, we help you choose what’s right for your home or business. Whether you’re exploring an On Grid Solar System or considering other options, our team will guide you every step of the way. Reach out today and take your first step towards smarter energy. ",
        
      },

      
    ]
  },
  {
  id: 2,
  slug: "ground-mounted-vs-rooftop-solar-roi",
  category: "Solar Guide",

  title:
    "Ground Mounted vs Rooftop Solar: Which Delivers Better ROI for Large Installations?",

  shortDescription:
    "When comparing <a class='text-[#117816] hover:underline' href='/blogs/ground-mounted-vs-rooftop-solar-roi'>Ground Mounted vs Rooftop Solar</a>, the real question is about ROI. For large solar installations in India and MW solar plants, the right choice depends on scalability, efficiency, and long-term value. Here’s a clear breakdown to help you decide which system delivers stronger returns.",

  image: blog2,

  author: "Savorka",
  date: "29 Apr 2026",
  readTime: "6 min read",

  content: [
    {
      heading: "Two Approaches, One Goal: Maximum Returns",
      description:
        "When choosing between ground mounted vs rooftop solar, the goal is simple—maximize energy generation and ROI. Rooftop systems use existing space efficiently, while ground mounted systems are designed for large-scale performance. For large solar installations in India, this difference directly impacts long-term returns."
    },

    {
      heading: "Rooftop Solar Systems",
      description:
        "Rooftop solar systems utilize unused roof space to generate clean energy. They are practical, cost-effective, and ideal for businesses looking to optimize existing infrastructure without heavy upfront investment."
    },

    {
      heading: "Ground Mounted Solar Systems",
      description:
        "Ground mounted systems are installed on open land with engineered structures. They are built for scale, precision, and higher performance, making them the preferred choice for MW solar plants."
    },

    {
      heading: "Scale That Matches Your Ambition",
      description:
        "Rooftop systems are limited by roof size and structural constraints. Ground mounted systems allow expansion, enabling higher energy generation and stronger ROI over time."
    },

    {
      heading: "Performance That Drives Profitability",
      description:
        "Ground mounted systems allow optimal tilt, spacing, and orientation, ensuring maximum sunlight exposure. Rooftop systems may face shading and design limitations, which can impact efficiency."
    },

    {
      heading: "Investment vs Value Creation",
      description:
        "Rooftop solar has a lower upfront cost, making it easier to adopt. Ground mounted systems require higher initial investment but deliver greater long-term returns through higher efficiency and scalability."
    },

    {
      heading: "Maintenance That Protects Performance",
      description:
        "Ground mounted systems are easier to access and maintain, allowing regular cleaning and better performance. Rooftop systems can be harder to manage at scale, especially in industrial setups."
    },

    {
      heading: "Space Optimization vs Capacity Expansion",
      description:
        "Rooftop solar makes use of existing structures, while ground mounted systems unlock large-scale generation potential where land is available—making them ideal for large installations."
    },

    {
      heading: "What Works Best for Large Installations?",
      subheading: "Ground mounted systems offer:",
      points: [
        "Higher generation capacity",
        "Better operational efficiency",
        "Easy scalability for future growth",
        "Stronger long-term ROI"
      ],
      description:
        "For MW solar plants and large industrial use, ground mounted systems consistently outperform rooftop setups due to their flexibility, efficiency, and scalability."
    },

    {
      heading: "Final Verdict",
      subheading: "Here’s the simple takeaway:",
      points: [
        "Rooftop Solar: Best for lower investment and faster payback",
        "Ground Mounted Solar: Best for scale, performance, and long-term ROI"
      ],
      description:
        "If your focus is long-term value and large-scale energy generation, ground mounted solar systems are usually the better investment."
    },

    {
      heading: "FAQs",
      subheading: "1. Which offers better ROI for large installations?",
      description:
        "Ground mounted solar systems generally deliver better ROI due to higher efficiency, scalability, and energy output."
    },

    {
      heading: "2. Can rooftop solar handle large industrial needs?",
      description:
        "Rooftop solar can reduce energy costs significantly, but for very high demand, it is often combined with ground mounted systems."
    },

    {
      heading: "3. Why are ground mounted systems used for MW plants?",
      description:
        "They allow large-scale deployment, better panel positioning, and consistent performance—making them ideal for MW solar plants."
    }
  ]
},
{
  id: 3,
  slug: "solar-subsidy-india-2026-state-wise-guide",
  category: "Solar Guide",

  title:
    "Solar Subsidy in India 2026: State-wise Guide for Homes & Businesses",

  shortDescription:
    "Planning to install rooftop solar but confused about subsidies, state-wise benefits, and actual savings? This guide explains the <a class='text-[#117816] hover:underline' href='/blogs/solar-subsidy-india-2026-state-wise-guide'>Solar Subsidy in India 2026</a>, including PM Surya Ghar Yojana benefits, state-wise rooftop solar support, net metering, and how homeowners and businesses can reduce electricity costs with solar energy.",

  image: blog3,

  author: "Savorka",
  date: "14 May 2026",
  readTime: "8 min read",

  content: [
    {
      heading: "Why More Indians Are Switching to Solar",
      description:
        "Solar energy is no longer just an eco-friendly option — it has become a smart financial investment. Rising electricity bills and improved solar technology are encouraging more people to generate their own power through rooftop solar systems."
    },

    {
      subheading: "Here’s why solar adoption is growing rapidly across India:",
      points: [
        "Significant reduction in monthly electricity bills",
        "Government subsidy support for residential users",
        "Protection against rising electricity tariffs",
        "Low maintenance and long system lifespan",
        "Eco-friendly and sustainable energy generation",
        "Increased property value for homes and commercial buildings"
      ],
      description:
        "A properly designed rooftop solar system can provide reliable savings for 25 years or more, making it a long-term energy solution for both homes and businesses."
    },

    {
      heading:
        "",
      description:
        "<a class='text-[#117816] hover:underline' href='/blogs/ground-mounted-vs-rooftop-solar-roi'>Read here - Ground Mounted vs Rooftop Solar: Which Delivers Better ROI for Large Installations?</a>"
    },

    {
      heading: "What is the PM Surya Ghar Yojana?",
      description:
        "The PM Surya Ghar: Muft Bijli Yojana is a major rooftop solar initiative launched by the Ministry of New and Renewable Energy (MNRE) to promote solar adoption among residential consumers."
    },

    {
      description:
        "The main aim of this scheme is to help households reduce electricity expenses by making rooftop solar systems more affordable through government subsidies."
    },

    {
      description:
        "Under this scheme, eligible homeowners can receive subsidy benefits based on the size of their rooftop solar installation. The subsidy amount is directly transferred to the consumer’s bank account after successful installation and approval."
    },

    {
      heading: "How Much Solar Subsidy Can You Get in 2026?",
      description:
        "The subsidy amount depends on the capacity of the rooftop solar system installed at your property."
    },

    {
      subheading: "Current central government subsidy benefits include:",
      points: [
        "Up to 1 kW solar system: Subsidy of ₹30,000",
        "Up to 2 kW solar system: Subsidy of ₹60,000",
        "3 kW and above: Subsidy benefits up to ₹78,000"
      ],
      description:
        "In some cases, combined benefits and local support can help consumers receive total benefits of up to ₹1,08,000."
    },

    {
      description:
        "At <a class='text-[#117816] hover:underline' href='/'>Savorka Solar</a>, our team assists customers throughout the subsidy process, helping ensure smoother approvals and faster implementation."
    },

    {
      heading: "State-wise Solar Benefits Across India",
      description:
        "Many Indian states are actively supporting rooftop solar adoption through better net metering policies, faster approvals, and improved solar infrastructure."
    },

    {
      heading: "Gujarat",
      points: [
        "Faster DISCOM approvals",
        "Strong residential solar adoption",
        "Excellent net metering support"
      ]
    },

    {
      heading: "Rajasthan",
      points: [
        "High solar energy generation potential",
        "Ideal weather conditions for rooftop solar",
        "Growing residential and commercial adoption"
      ]
    },

    {
      heading: "Uttar Pradesh",
      points: [
        "Expanding rooftop solar initiatives",
        "Better financing support",
        "Increasing urban solar adoption"
      ]
    },

    {
      heading: "Haryana",
      points: [
        "Supportive rooftop solar policies",
        "Growing awareness and adoption",
        "Simplified approval processes"
      ]
    },

    {
      heading: "Maharashtra",
      points: [
        "Strong commercial solar growth",
        "Better long-term electricity savings",
        "Improved financing options"
      ]
    },

    {
      heading: "Delhi",
      points: [
        "Net metering support",
        "Lower electricity expenses",
        "Focus on sustainable urban energy solutions"
      ]
    },

    {
      heading: "Why Rooftop Solar Makes Sense for Homeowners",
      description:
        "Residential consumers receive the highest direct benefits under the PM Surya Ghar Yojana. Installing rooftop solar can drastically reduce household electricity expenses while also increasing long-term property value."
    },

    {
      subheading: "Benefits of residential rooftop solar systems include:",
      points: [
        "Subsidy support up to ₹78,000",
        "Electricity bill savings of up to 70–90%",
        "Eco-friendly energy generation",
        "Minimal maintenance costs",
        "Long operational life of 25+ years"
      ],
      description:
        "At Savorka Solar, we provide customized rooftop solar solutions designed according to your roof structure and energy requirements."
    },

    {
      heading: "How Businesses Benefit from Solar Energy",
      description:
        "Although direct central subsidies are mainly available for residential consumers, commercial and industrial users still gain major financial advantages through solar adoption."
    },

    {
      subheading: "Benefits for businesses include:",
      points: [
        "Reduced operational electricity costs",
        "Higher return on investment",
        "Protection from increasing energy tariffs",
        "Better sustainability and ESG compliance",
        "Improved long-term profitability"
      ],
      description:
        "Commercial solar systems are now widely installed in factories, offices, schools, warehouses, hotels, hospitals, and retail spaces across India."
    },

    {
      description:
        "Savorka offers scalable commercial and industrial solar EPC solutions tailored to businesses of all sizes."
    },

    {
      heading: "What is Net Metering?",
      description:
        "Net metering is an important rooftop solar feature that allows consumers to export excess electricity generated by their solar system back to the power grid."
    },

    {
      description:
        "The exported units are adjusted against the electricity imported from the grid, helping reduce the final electricity bill. Most Indian states now support net metering for residential and commercial rooftop solar systems."
    },

    {
      heading: "Simple Steps to Apply for Solar Subsidy",
      description:
        "The solar subsidy process has become easier through the national rooftop solar portal."
    },

    {
      subheading: "Step 1: Choose a Trusted Solar Company",
      description:
        "Select an experienced provider like Savorka Solar for installation and subsidy support."
    },

    {
      subheading: "Step 2: Register for Subsidy",
      description:
        "Submit your rooftop solar application through the official portal."
    },

    {
      subheading: "Step 3: Technical Approval",
      description:
        "The local DISCOM checks the technical feasibility of the installation."
    },

    {
      subheading: "Step 4: Solar Installation",
      description:
        "The system is installed according to approved standards."
    },

    {
      subheading: "Step 5: Inspection and Net Metering",
      description:
        "The installed system is inspected and net metering is activated."
    },

    {
      subheading: "Step 6: Receive Subsidy Amount",
      description:
        "The approved subsidy amount is directly credited to your bank account."
    },

    {
      heading: "Why Choose Savorka Solar?",
      description:
        "Choosing the right solar partner plays an important role in maximizing savings and ensuring smooth project execution."
    },

    {
      subheading: "At Savorka Solar, we provide:",
      points: [
        "Residential rooftop solar solutions",
        "Commercial and industrial solar EPC services",
        "Customized solar system design",
        "Subsidy consultation and documentation support",
        "High-quality solar panels and inverters",
        "Professional installation and maintenance services",
        "End-to-end project management"
      ],
      description:
        "Our goal is to help customers adopt clean energy through reliable, efficient, and cost-effective solar solutions."
    }
  ]
},
{
  id: 4,
  slug: "how-to-choose-right-solar-epc-company-india",
  category: "Solar Guide",

  title: "How to Choose the Right Solar EPC Company in India: 7 Things to Check",

  shortDescription:
    "Choosing the right <a class='text-[#117816] hover:underline' href='/blogs/how-to-choose-right-solar-epc-company-india'>Solar EPC company in India</a> is one of the most important decisions you'll make on your solar journey. With hundreds of providers in the market, how do you separate the reliable from the rest? Whether you're installing a rooftop solar system at home or planning a large commercial project, this guide covers 7 essential things to check before you commit to a solar EPC partner.",

  image: blog4,

  author: "Savorka",
  date: "22 May 2026",
  readTime: "8 min read",

  content: [
    {
      heading: "Understanding the Role of a Solar EPC Company",
      description:
        "A Solar EPC (Engineering, Procurement, and Construction) company is responsible for managing the complete lifecycle of a solar project, from initial assessment to final commissioning. Their scope of work typically includes site inspection, customized system planning, sourcing of panels and inverters, installation, net metering assistance, and long-term maintenance support. An experienced EPC partner ensures your system is designed and executed for reliable performance, operational safety, and maximum energy efficiency over its full lifespan."
    },

    {
      heading: "1. Assess the Company's Industry Experience and Project Portfolio",
      description:
        "In the solar sector, experience plays a vital role in ensuring technical precision and project reliability. Companies with a proven track record are generally better equipped to manage complex installations, regulatory processes, and execution challenges.",
      subheading: "Key areas to evaluate:",
      points: [
        "Years of experience in the solar industry",
        "Total installed project capacity",
        "Diversity of completed projects",
        "Expertise across residential, commercial, and industrial segments",
        "Client portfolio and case studies"
      ]
    },

    {
      heading: "2. Evaluate the Quality of Solar Components",
      description:
        "The quality of components used directly impacts the performance, durability, and long-term returns of a solar power system. Since solar installations are designed to operate for decades, component selection should be approached with careful consideration.",
      subheading: "Industry-standard warranty benchmarks to look for:",
      points: [
        "Solar modules: up to 25 years performance warranty",
        "Inverters: typically 5–10 years",
        "Installation / workmanship: 1–5 years"
      ]
    },

    {
      heading: "3. Verify Certifications and Compliance Standards",
      description:
        "A credible Solar EPC company should operate in accordance with recognized quality, safety, and regulatory standards. For commercial and industrial installations, compliance becomes even more critical due to operational and business continuity requirements.",
      subheading: "Certifications and compliances to review:",
      points: [
        "MNRE-related approvals or registrations",
        "ISO certifications",
        "BIS-certified products",
        "Electrical and safety compliance standards"
      ]
    },

    {
      heading: "4. Review Engineering and Design Capabilities",
      description:
        "Every site has unique structural and energy requirements. A professional EPC company should offer customized engineering solutions rather than a standardized, one-size-fits-all approach. Robust system design directly influences energy generation output, return on investment, payback period, and system lifespan.",
      subheading: "A well-qualified EPC partner should:",
      points: [
        "Conduct detailed site feasibility assessments",
        "Analyze shadow-free zones and structural suitability",
        "Design optimized system layouts",
        "Provide accurate generation and savings estimates"
      ]
    },

    {
      heading: "5. Evaluate Installation Standards and After-Sales Support",
      description:
        "While installation quality is essential, long-term support and service capabilities are equally important in ensuring uninterrupted system performance. Timely issue resolution minimizes downtime and protects overall system productivity.",
      subheading: "Before finalizing a company, evaluate:",
      points: [
        "Availability of AMC (Annual Maintenance Contracts)",
        "Monitoring and remote diagnostics capabilities",
        "Response timelines for technical support",
        "On-site service availability"
      ]
    },

    {
      heading: "6. Compare Pricing with Complete Transparency",
      description:
        "Pricing should always be evaluated alongside quality, warranties, and long-term performance expectations. In some cases, lower quotations may exclude important project elements such as net metering support, structural modifications, or additional installation costs. A slightly higher upfront investment often results in stronger long-term financial and operational benefits.",
      subheading: "Request a detailed proposal including:",
      points: [
        "Equipment specifications and brands",
        "Complete scope of installation",
        "Warranty coverage",
        "Taxes and applicable subsidies",
        "Maintenance and support costs"
      ]
    },

    {
      heading: "7. Review Customer Feedback and Market Reputation",
      description:
        "Client testimonials and market reputation provide valuable insights into a company's professionalism, execution quality, and service standards. Where possible, interacting directly with existing customers can offer practical insight into actual energy savings achieved and overall service experience.",
      subheading: "Sources to review:",
      points: [
        "Google reviews and ratings",
        "Client testimonials on the company website",
        "Social media presence and engagement",
        "Completed project showcases and case studies"
      ]
    },

    {
      heading: "Subsidy and Net Metering Assistance",
      description:
        "An efficient Solar EPC company should also provide support with government subsidy applications, net metering approvals, and DISCOM coordination. This assistance simplifies the installation process and helps ensure faster project execution, particularly for residential rooftop solar projects under the PM Surya Ghar Yojana.",
    },

    {
      heading: "Common Mistakes to Avoid",
      subheading: "Watch out for these pitfalls when choosing a solar EPC partner:",
      points: [
        "Selecting solely on the basis of low pricing — lower costs may indicate compromises in quality or support",
        "Ignoring post-installation support — reliable after-sales service is essential for long-term performance",
        "Overlooking project experience — always verify relevant project history at a similar scale",
        "Not reviewing warranty terms carefully — comprehensive warranties indicate confidence in the product and installation"
      ]
    },

    {
      heading: "Final Thoughts",
      description:
        "Selecting the right Solar EPC company in India is a strategic decision that directly influences the efficiency, reliability, and financial performance of your solar power system. As India continues progressing toward a more sustainable energy future, partnering with the right solar company today can deliver measurable economic and environmental benefits for decades to come."
    },

    {
      heading: "Why Choose Savorka Solar?",
      description:
        "At <a class='text-[#117816] hover:underline' href='/'>Savorka Solar</a>, we bring together technical expertise, quality components, transparent pricing, and end-to-end support to deliver solar solutions that truly perform. Whether you're a homeowner looking to reduce electricity bills or a business planning a large-scale installation, our team guides you every step of the way — from design and installation to subsidies and long-term maintenance."
    }
  ]
}
];

export default blogsData;